import { render, staticRenderFns } from "./FieldType10Configure.vue?vue&type=template&id=caba3e8c&scoped=true"
import script from "./FieldType10Configure.vue?vue&type=script&lang=js"
export * from "./FieldType10Configure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caba3e8c",
  null
  
)

export default component.exports